import * as z from "zod";

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

export const exportAuditRowSchema = z.object({
  id: z.string(),
  merchantId: z.string(),
  name: z.string(),
  type: z.enum(["Self-Serve", "Custom"]),
  startDateTime: z.string(),
  lastSessionAt: z.string(),
  dealSize: z.number().nullable(),
  onboardingProgress: z.enum([
    "Completed",
    "Reopened",
    "Awaiting approval",
    "In progress",
    "Partial Completion",
    "Help Requested",
  ]),
  pushConfigurationDate: z.string().nullable(),
  durationSeconds: z.number().nullable(),
  totalSessions: z.number().nullable(),
  completionPercent: z.number().nullable(),
  weightedRevenue: z.number().nullable(),
  weightPercent: z.number().nullable(),
  cumulativeStepTimes: z.record(z.string(), z.any()).nullable(),
  /** Raw v2 step timestamps (keyed by step id). Only present on v2 rows. */
  v2StepTimestamps: z.record(z.string(), z.any()).nullable().optional(),
});

export const exportWeightedAudit = {
  name: "exportWeightedAudit" as const,
  input: z
    .object({
      timePeriod: timePeriodSchema,
      customRange: customRangeSchema.optional(),
      searchQuery: z.string().optional(),
      filterLowIntent: z.boolean().optional(),
    })
    .superRefine((value, ctx) => {
      if (value.timePeriod === "custom" && !value.customRange) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "customRange is required when timePeriod is custom",
          path: ["customRange"],
        });
      }
    }),
  output: z.object({
    onboardings: z.array(exportAuditRowSchema),
    total: z.number(),
  }),
};

export type ExportAuditRow = z.infer<typeof exportAuditRowSchema>;
export type ExportWeightedAuditInput = z.infer<
  typeof exportWeightedAudit.input
>;
export type ExportWeightedAuditOutput = z.infer<
  typeof exportWeightedAudit.output
>;
